import { useTheme } from "@/components/ui/theme-provider";
import { FLAVOR_CONFIG } from "@/lib/flavor-config";

// NOTE: NSAI-6321 — the single place the product's user-facing name is
// resolved. An organization can set its own in Appearance, and everything that
// used to read `FLAVOR_CONFIG.appName` directly now goes through here so a
// white-label customer is named consistently: the browser tab, the Take-a-tour
// dialog, the chat disclaimer, the bot sections, the organization settings copy.
//
// The flavor value is the fallback, not the value: the server never sends a
// default, because the same backend serves the NodeShift and Oplot bundles and
// only the bundle knows which product it is. A blank saved name resolves to the
// fallback too — an empty tab title is never the right answer.
export const useAppName = (): string => {
  const { appName } = useTheme();

  return appName?.trim() || FLAVOR_CONFIG.appName;
};
